import { el } from 'redom';

import EventBackgroundImage from 'assets/images/event-background-image.png';
import eventLocationTypes from 'constants/event-location-types';
import application from 'application';

class JoinInstructionsDisplay {

  constructor(event) {

    this.event = event;

    this.eventJoiningInstruction = this.getEventJoiningInstruction();

    this.eventJoiningInstructionLabelViewEl = el('label.event-joining-instruction-label', 'Joining Instructions');
    this.eventJoiningInstructionViewEl = el('label.event-joining-instruction ellipsis', this.eventJoiningInstruction);

    this.eventJoiningInstructionTooltipTextViewEl = el('label.event-joining-instruction-tooltip-text', this.eventJoiningInstruction);
    this.eventJoiningInstructionTooltipContainerViewEl = el('div.event-joining-instruction-tooltip-container', [this.eventJoiningInstructionTooltipTextViewEl]);

    this.eventJoiningInstructionContentContainerViewEl = el('div.event-joining-instuction-content-container', [this.eventJoiningInstructionViewEl, this.eventJoiningInstructionTooltipContainerViewEl]);;
    this.eventJoiningInstructionContainerViewEl = el('div.event-joining-instructions-container-view', [this.eventJoiningInstructionLabelViewEl, this.eventJoiningInstructionContentContainerViewEl]);

    this.el = el('.event-joining-instructions-main', {
      style: this.getImageStyles()
    }, [this.eventJoiningInstructionContainerViewEl]);

  }

  getImageStyles() {

    return `
      background-image: url(${EventBackgroundImage});
    `;

  }

  getLiveStreamURL() {

    const event = this.event;

    const startup = application.getCurrentStartup();

    const url = `${startup.address.url}/community/${event.postId}/live`;

    return url;
  }

  getEventJoiningInstruction() {

    const event = this.event;

    if (event.location.type === eventLocationTypes.HELPTAP_LIVESTREAM) {

      const livestreamingURL = this.getLiveStreamURL();

      return livestreamingURL;

    }

    const otherLocation = event.location.value;

    return otherLocation;

  }

};

export default JoinInstructionsDisplay;